import { hasPaladinFeature, isSmiteAttack } from '../../../../shared/rules/paladin.mjs';

export const RADIANT_STRIKES_FEATURE_ID = 'paladin:radiant-strikes';
const LABEL = 'Radiant Strikes';
const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: RADIANT_STRIKES_FEATURE_ID, featureLabel: LABEL, reasonCode });

/**
 * 2024 Radiant Strikes (Paladin 11): every hit with a Melee weapon or an Unarmed Strike deals an extra 1d8 Radiant
 * damage. Always on and not once per turn, so it applies automatically without a usage claim (like Divine Favor).
 */
export const evaluateRadiantStrikes = ({ context }) => {
  if (!hasPaladinFeature(context?.attacker?.entity, 'radiantStrikes')) return ineligible('below-level-11');
  if (context?.roll?.hit === false) return ineligible('not-a-hit');
  if (!isSmiteAttack(context?.attack)) return ineligible('not-melee-hit');
  return {
    status: 'automatic', featureId: RADIANT_STRIKES_FEATURE_ID, featureLabel: LABEL, reasonCode: 'radiant-strikes',
    components: [{ id: RADIANT_STRIKES_FEATURE_ID, label: LABEL, source: { type: 'feature', featureId: RADIANT_STRIKES_FEATURE_ID },
      dice: { count: 1, sides: 8 }, flat: 0, damageType: { mode: 'explicit', value: 'radiant' }, critical: { dice: 'double' } }],
    claims: [],
  };
};
